/*
 * Engravity site extras (all pages)
 * - "Back to top" button that appears after scrolling down.
 */
(function () {
  var CSS = '' +
    '.egt-top{position:fixed;right:16px;bottom:24px;z-index:4;width:44px;height:44px;border-radius:50%;border:0;padding:0;background:var(--accent-color,#1F4656);color:#fff;box-shadow:0 4px 14px rgba(0,0,0,.18);display:flex;align-items:center;justify-content:center;cursor:pointer;opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity .25s,transform .25s,visibility .25s,bottom .25s}' +
    '.egt-top.is-visible{opacity:1;visibility:visible;transform:none}' +
    '.egt-top:hover{filter:brightness(1.12)}' +
    '.egt-top svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}' +
    '@media (min-width:1000px){.egt-top{right:28px;bottom:28px}}';

  function init() {
    if (document.querySelector('.egt-top')) return;
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'egt-top';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 14l6-6 6 6"/></svg>';
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    document.body.appendChild(b);

    var shown = false;
    function check() {
      var on = window.scrollY > 700;
      if (on !== shown) { shown = on; b.classList.toggle('is-visible', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
